import { colors } from '../../../../../packages';
import dayjs from 'dayjs';
import { shortNumber } from '../../../../../utils/CommonUtils';

export const chartOptions = {
  chart: {
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  title: {
    text: '',
  },
  plotOptions: {
    bar: {
      horizontal: false,
    },
  },
  colors: [colors.primary500],
  stroke: {
    width: 2,
    colors: [colors.primary500],
    curve: 'smooth',
  },
  xaxis: {
    tickAmount: 12,
    labels: {
      formatter: val => {
        return dayjs(val).format('MMM D');
      },
      style: {
        fontFamily: 'Manrope',
        fontWeight: 600,
      },
    },
    tooltip: {
      enabled: false,
    },
  },
  yaxis: {
    title: {
      text: undefined,
    },
    labels: {
      formatter: value => {
        return Math.round(value).toString();
      },
    },
  },
  tooltip: {
    style: {
      fontFamily: 'Manrope',
    },
    y: {
      formatter: shortNumber,
      show: false,
    },
  },
  fill: {
    opacity: 1,
  },
  legend: {
    show: false,
  },
};
